import {ChangeDetectorRef, Component, Input, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as pbi from 'powerbi-client';
import {ApiClhubService} from '../../../_services/apiClhub.service';
import {IEmbedConfiguration} from 'embed';
import * as $ from 'jquery';
import {BackgroundType, IBasicFilter, Permissions, TokenType, ViewMode} from 'powerbi-models';
import {User} from '../../../_models/user.model';
import {AuthenticationService} from '../../../_services/authentication.service';
import {Subject} from 'rxjs';
import {EmbedConfig} from '../../../_models/EmbedConfig';
import {UserOrGroupModel} from '../../../_models/DAL/UserOrGroup.model';
import {FavoritePowerBIObjectModel} from '../../../_models/DAL/FavoritePowerBIObject.model';
import { AppGlobal, AutoRefresh } from 'src/environments/app.global';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrls: ['./report-view.component.css']
})
export class ReportViewComponent implements OnInit {
    private refreshIntervalId: any;
    private asAutoRefresh: boolean = false;
    public RapportName = '';
    public FavoriteReport = false;
    private currentReport: any;
    private mySelf: any;
    private _authenticationSubject: Subject<EmbedConfig> = new Subject<EmbedConfig>();
    public AuthenticationBI = this._authenticationSubject.asObservable();
    private currentUser: User;

  constructor(private route: ActivatedRoute, private router: Router,
              private ngZone: NgZone, private apiClient: ApiClhubService, private cdRef: ChangeDetectorRef,
              private authenticationService: AuthenticationService) {
                this.ngZone.run(async () => { });
                
                this.currentUser = this.authenticationService.currentUserValue;
                
                this.route.params.subscribe(result => {
                  
      this.apiClient.get('PowerBi/embedPowerBIObject?powerBIObjectId=' + result.id +
        '&azureIdCurrentUser=' + this.currentUser.azure_id +
        '&userPincipalName=' + this.currentUser.email +
        '&groupsId=' + this.currentUser.groupsid.join(';') +
        '&customData=' + this.currentUser.email).subscribe(EmbedConfigResult => {
          this._authenticationSubject.next(EmbedConfigResult);
        });
        
        // Dès que nous avons notre authentication
        this.AuthenticationBI.subscribe(authenticationResult => {
          this.currentReport = authenticationResult;
          
          if (this.currentReport.favoriteEmbed) {
            this.FavoriteReport = true;
          }
          this.RapportName = this.currentReport.embeddedObjectName;
          this.cdRef.detectChanges();
          
          // Report FilterPane display
          const filterPane = this.currentReport.powerBIObject.displayFilterTable;
          
          this.asAutoRefresh = AutoRefresh.reports.includes(this.currentReport.powerBIObject.id);

        // Embed URL
        const embedUrl = 'https://app.powerbi.com/reportEmbed?reportId=' +
          this.currentReport.powerBIObject.azureObjectId + '&groupId=' + this.currentReport.powerBIObject.azureWorkspaceId;

        const filters: IBasicFilter[] = [];

        const typeToken = TokenType.Embed;

        // Configuration used to describe the what and how to embed.
        // This object is used when calling powerbi.embed.
        // This also includes settings and options such as filters.
        // You can find more information at https://github.com/Microsoft/PowerBI-JavaScript/wiki/Embed-Configuration-Details.
        const config: IEmbedConfiguration = {
          type: 'report',
          accessToken: this.currentReport.embedToken.token,
          tokenType : typeToken,
          embedUrl: embedUrl,
          uniqueId: this.currentReport.powerBIObject.azureObjectId,
          groupId: this.currentReport.powerBIObject.azureWorkspaceId,
          settings: {
            filterPaneEnabled: filterPane,
            navContentPaneEnabled: true,
            background: BackgroundType.Default,
            localeSettings: {
              language: this.authenticationService.currentUserValue.lang,
              formatLocale: this.authenticationService.currentUserValue.lang
            }
          },
          viewMode: ViewMode.View,
          permissions: Permissions.Read,
          filters: filters
        };

        // Grab the reference to the div HTML element that will host the report.
        const reportContainer = <HTMLElement>document.getElementById('reportContainer');

        // Embed the report and display it within the div container.
        const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
        const reportFinal = powerbi.embed(reportContainer, config)  as pbi.Embed & pbi.Report;


        if(this.asAutoRefresh){
          // 🔁 Rafraîchissement automatique toutes les 60 secondes
            this.refreshIntervalId = setInterval(() => {
              reportFinal.refresh();
              console.log(`refresh ${this.refreshIntervalId}` );
            }, AutoRefresh.reportRefresTime);
        }

        reportFinal.iframe.frameBorder = '0px';
        $('#reportContainer>iframe').css('height', '92vh');

        // Report.off removes a given event handler if it exists.
        reportFinal.off('loaded');
        // Report.on will add an event handler which prints to Log window.
        reportFinal.on('loaded', function() {

        });
      });
    });
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }
  

}
